import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    editors: null,
    editorToDeactivate: null,
    currentPage: 1,
};
const editorsSlice = createSlice({
    name: 'editors',
    initialState,
    reducers: {
        setEditors: (state, action) => {
            state.editors = action.payload;
        },
        setEditorToDeactivate: (state, action) => {
            state.editorToDeactivate = action.payload;
        },
        setEditorsCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
    },
    selectors: {
        selectEditors: (state) => state.editors,
        selectEditorToDeactivate: (state) => state.editorToDeactivate,
        selectEditorsCurrentPage: (state) => state.currentPage,
    },
});
export const { setEditors, setEditorToDeactivate, setEditorsCurrentPage } = editorsSlice.actions;
export const { selectEditors, selectEditorToDeactivate, selectEditorsCurrentPage } = editorsSlice.selectors;
export default editorsSlice.reducer;
